import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { RotateCw, FileVideo } from 'lucide-react';
import './HistoryPage.css';

const API_BASE = process.env.REACT_APP_API_BASE_URL || 'http://localhost:5001';

export const HistoryPage = ({ session }) => {
  const [history, setHistory] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const navigate = useNavigate();

  useEffect(() => {
    if (!session?.access_token) {
      setLoading(false);
      return;
    }

    const fetchHistory = async () => {
      try {
        const res = await fetch(`${API_BASE}/api/history?limit=50`, {
          headers: { Authorization: `Bearer ${session.access_token}` }
        });
        const json = await res.json();
        if (json.error) throw new Error(json.error);
        setHistory(json.data || []);
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchHistory();
  }, [session]);

  const handleRedownload = (url) => {
    navigate('/downloader', { state: { url } });
  };

  return (
    <div className="page-container history-page">
      <div className="history-header">
        <h1>Download History</h1>
      </div>
      {loading && <p>Loading...</p>}
      {error && <p className="error">{error}</p>}

      <div className="history-list">
        {history.length === 0 && !loading && <p className="empty-state">No downloads yet.</p>}
        {history.map(item => (
          <div key={item.id} className="history-item">
            <div className="history-thumb">
              {item.video_thumbnail ? (
                <img src={item.video_thumbnail} alt="" onError={(e) => e.target.style.display = 'none'} />
              ) : <FileVideo size={32} />}
            </div>
            <div className="history-details">
              <div className="history-title">{item.video_title || item.video_url}</div>
              <div className="history-meta-row">
                <span className="history-date">{new Date(item.download_date).toLocaleDateString()} {new Date(item.download_date).toLocaleTimeString()}</span>
                <span className="history-badge" style={{ background: 'rgba(238, 186, 44, 0.15)', color: '#eeba2c' }}>
                  {item.download_type === 'audio' ? 'MP3' : 'MP4'}
                </span>
                <span className={`history-badge ${item.has_watermark ? 'warn' : 'success'}`}>
                  {item.has_watermark ? 'Watermarked' : 'Clean'}
                </span>
              </div>
            </div>
            <button
              onClick={() => handleRedownload(item.video_url)}
              className="history-action-btn"
              title="Download again"
            >
              <RotateCw size={18} />
            </button>
          </div>
        ))}
      </div>
    </div>
  );
};

